import { render, staticRenderFns } from "./MessageCenterDialog.vue?vue&type=template&id=c34485ae&scoped=true"
import script from "./MessageCenterDialog.vue?vue&type=script&lang=js"
export * from "./MessageCenterDialog.vue?vue&type=script&lang=js"
import style0 from "./MessageCenterDialog.vue?vue&type=style&index=0&id=c34485ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c34485ae",
  null
  
)

export default component.exports